import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
type RevealProps = {
  children: React.ReactNode;
  className?: string;
  delay?: number;
};
export function Reveal({
  children,
  className = '',
  delay = 0
}: RevealProps) {
  const reduceMotion = useReducedMotion();
  return <motion.div className={className} initial={reduceMotion ? false : {
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.18
  }} transition={{
    duration: 0.48,
    delay,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-25">
      {children}
    </motion.div>;
}